// extracted by mini-css-extract-plugin
export default {"AddLocation":"AddLocation_AddLocation__VJavI","form":"AddLocation_form__sgIuW"};